import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import privacyProject from "../../Assets/Projects/privacyProject.png";
import littleLemon from "../../Assets/Projects/littleLemon.png";
import whatYouRather from "../../Assets/Projects/whatYouRather.png";
import popMainPage from "../../Assets/Projects/popMainPage.png";
import doBetterMain from "../../Assets/Projects/doBetterMain.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={littleLemon}
              isBlog={false}
              title="Little Lemon"
              description="Built entirely in React for the Meta Front-End Developer certificate. Includes a booking form, menu, and fully responsive UI."
              ghLink="https://github.com/hayderAtiyah/little-lemon.git"
              demoLink="https://coruscating-kitten-3251f2.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={whatYouRather}
              isBlog={false}
              title="What would you rather (val edition)"
              description="A game using React, Spring Boot, and MongoDB. User choices update live in the database. I connect React (front-end), Spring Boot (API), and MongoDB (data) for real-time updates."
              ghLink="https://github.com/hayderAtiyah/would-you-rather-in-Valorant.git"
              // demoLink="comming so soon"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={popMainPage}
              isBlog={false}
              title="POP-BEAT Management Page"
              description="MERN stack project: React front-end, Node.js & Express.js backend, and MongoDB database. Built a management dashboard for radio playlists, DJ assignments, and reports."
              ghLink="https://github.com/hayderAtiyah/PopBeat-Radio.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={doBetterMain}
              isBlog={false}
              title="DO BETTER"
              description="Hackathon project for Peraton Challenge using React. Lets users upload eco-friendly deeds, with image analysis and feedback. Built with React, Node.js, and AWS services."
              ghLink="https://github.com/sriya-med/PatriotHacks24_DoBetter.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={privacyProject}
              isBlog={false}
              title="Privacy Policy Summarizer"
              description="React web app that lets users upload or paste a privacy policy and get a simplified summary using AI. I built it using React.js and the OpenAI API. It extracts text from PDF files or input fields, sends it to OpenAI for summarization, and displays the result clearly."
              ghLink="https://github.com/hayderAtiyah/privacy-policy-summarizer.git"
              demoLink="https://fantastic-buttercream-dd68fe.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
